var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVectorFullWidth = function SvgVectorFullWidth(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    viewBox: "0 0 1920 114",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1457.99 75.7629L1882 75.7628C1912.93 75.7628 1920 68.2497 1920 47.2628L1920 -0.000152588L-1.02054e-05 1.13297e-05C-9.08842e-06 12.4773 14.9061 22.5922 33.2937 22.5922L165.487 22.5922C175.33 22.5922 183.31 28.0071 183.31 34.6867C183.31 41.3663 191.29 46.7811 201.133 46.7811L1038.11 46.7811C1065.46 46.7811 1087.64 61.8285 1087.64 80.3906C1087.64 98.9526 1109.81 114 1137.17 114L1401.64 114C1417.2 114 1429.82 105.44 1429.82 94.8815C1429.82 84.3226 1442.43 75.7629 1457.99 75.7629Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVectorFullWidth);
export default ForwardRef;